<template>
  <div>
    <v-card v-for="key in salesKeys" :key="`summary_${key}`" class="sales-summary">
      <v-card-title class="font-size--16">
        매출 발생일:
        {{ getSalesDate(key) }}
      </v-card-title>
      <v-card-text>
        <table>
          <tr>
            <td class="font-size--16">카드({{ salesSummary[key].cardCount | commaFormat }}건)</td>
            <td class="money font-size--16">{{ salesSummary[key].cardSales | commaFormat }} 원</td>
          </tr>
          <tr>
            <td class="font-size--16">배민({{ salesSummary[key].baeminCount | commaFormat }}건)</td>
            <td class="money font-size--16">
              {{ salesSummary[key].baeminSales | commaFormat }} 원
            </td>
          </tr>
          <tr>
            <td class="font-size--16">총 매출</td>
            <td class="money font-size--16">{{ salesSummary[key].totalSales | commaFormat }} 원</td>
          </tr>
          <tr>
            <td class="cancel font--m-4">(-) 카드수수료</td>
            <td class="cancel money font--m-4">
              <span v-if="salesSummary[key].cardFee > 0"> - </span>
              {{ salesSummary[key].cardFee | commaFormat }} 원
            </td>
          </tr>
          <tr>
            <td class="cancel font--m-4">(-) 배민수수료</td>
            <td class="cancel money font--m-4">
              <span v-if="salesSummary[key].baeminFee > 0"> - </span>
              {{ salesSummary[key].baeminFee | commaFormat }} 원
            </td>
          </tr>
          <tr>
            <td class="font--m-4 font-weight-black">입금 예정 금액</td>
            <td class="money font--m-4 font-weight-black">
              {{ salesSummary[key].totalTransfer | commaFormat }} 원
            </td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    date: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('earlyPayment', {
      isLoading1: 'getEarlyPaymentsLoading',
      isLoading2: 'getSalesSummaryLoading',
      earlypayments: 'getEarlyPayments',
      salesSummary: 'getSalesSummary',
    }),
    isLoading() {
      return this.isLoading1
    },
    startToEnd() {
      const result = []
      if (!this.earlypayments?.totalTransfer) {
        return result
      }
      const s = this.earlypayments?.salesStartDate || this.date
      const e = this.earlypayments?.salesEndDate || this.date

      const start = this.$moment(s)
      const end = this.$moment(e)
      const dayDiff = end.diff(start, 'days') + 1

      for (let index = dayDiff; index >= 1; index--) {
        const temp = this.$moment(e)
        const date = temp.subtract(index - 1, 'days').format('YYYY-MM-DD')

        result.push(date)
      }

      return result
    },
    salesKeys() {
      return this.startToEnd.filter((key) => {
        return !!this.salesSummary?.[key]
      })
    },
  },
  watch: {
    startToEnd: {
      deep: true,
      async handler(v) {
        for (let index = 0; index < v.length; index++) {
          const date = v[index]
          await this.getSalesSummary(date)
        }
      },
    },
  },
  methods: {
    ...mapActions('earlyPayment', ['getSalesSummary']),
    getSalesDate(date) {
      return this.$moment(date).format('YYYY-MM-DD (dd)')
    },
  },
}
</script>
<style lang="scss" scoped>
.sales-summary:not(:last-child) {
  margin-bottom: 20px;
}

.v-card {
  width: 100%;

  table {
    width: 100%;
    tr {
      td {
        width: 50%;
        padding-bottom: 4px;
      }

      .money {
        text-align: right;
      }

      .cancel {
        color: #a0a0a0;
      }
    }
  }
}
</style>
